export default [
{
  minWords: 150,
  priceIndex: 0,
  label: 'Up to 1 min or 150 words',
  duration: '1MIN'
},
{
  minWords: 300,
  priceIndex: 1,
  label: 'Up to 2 min or 300 words',
  duration: '2MIN'
},
{
  minWords: 750,
  priceIndex: 2,
  label: 'Up to 5 min or 750 words',
  duration: '5MIN'
}];